export enum WazzupTokenKind {
  api = 'api',
  sidecar = 'sidecar'
}
